import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

import { HomeLayoutComponent, loginLayoutComponent, OnboardLayoutComponent } from '@app/layout';
import { NotFoundComponent } from '@app/shared';
import { AuthGuard, NoAuthGuard, NotPlayerGuard, PlayerGuard } from '@app/core';

const routes: Routes = [
  {
    path: '',
    component: loginLayoutComponent,
    canActivate: [NoAuthGuard],
    data: { title: 'Home' },
    loadChildren: () => import('@modules/auth/auth.module').then(m => m.authModule),
  },
  {
    path: 'user',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard, NotPlayerGuard],
    data: { title: 'Users', breadcrumb: 'USER.USERS' },
    loadChildren: () => import('@modules/users/user.module').then(m => m.UserModule),
  },
  {
    path: 'course',
    component: HomeLayoutComponent,
    data: { title: 'Courses', breadcrumb: 'COURSE.ADD.COURSES' },
    loadChildren: () => import('@courses/course.module').then(m => m.CourseModule),
  },
  {
    path: 'profile',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    data: { title: 'Profile', breadcrumb: 'USER.PROFILE' },
    loadChildren: () => import('@modules/profile/profile.module').then(m => m.ProfileModule),
  },
  {
    path: 'onboard',
    component: OnboardLayoutComponent,
    canActivate: [AuthGuard, PlayerGuard],
    data: { title: 'Onboard' },
    loadChildren: () => import('@modules/onboard/onboard.module').then(m => m.OnboardModule),
  },
  {
    path: 'course/:id/pay',
    component: OnboardLayoutComponent,
    canActivate: [AuthGuard, PlayerGuard],
    data: { title: 'Course Payment' },
    loadChildren: () => import('@modules/payment/payment.module').then(m => m.PaymentModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: false, preloadingStrategy: QuicklinkStrategy }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
